import { SubjectType } from 'models/subject-type';
const BWL_SUBJECT_ICON = '/icons/subjects/bwl.png';
const CHEMISTRY_SUBJECT_ICON = '/icons/subjects/chemistry.png';
const SPANISH_SUBJECT_ICON = '/icons/subjects/spanish.png';
const MATH_SUBJECT_ICON = '/icons/subjects/math.png';
const PHYSICS_SUBJECT_ICON = '/icons/subjects/physics.png';
const LATIN_SUBJECT_ICON = '/icons/subjects/latin.png';
const ACCOUNTANCY_ICON = '/icons/subjects/accountancy.png';
const LRSDYSCALCULIA = '/icons/subjects/lrs-dyscalculia.png';
const ACCOUNTING_ICON = '/icons/subjects/accounting.png';
const RUSSIAN_ICON = '/icons/subjects/russian.png';
const LAW_ICON = '/icons/subjects/law.png';
const GERMANY_ICON = '/icons/subjects/german.png';
const COACHING_ICON = '/icons/subjects/coaching.png';
const CS_ICON = '/icons/subjects/cs.png';
const HISTORY_ICON = '/icons/subjects/history.png';
const GEOGRAPHY_ICON = '/icons/subjects/geography.png';
const ITALIAN_ICON = '/icons/subjects/italian.png';
const OTHER_ICON = '/icons/subjects/others.png';
const CONVERSATION_ICON = '/icons/subjects/conversation.png';
const BIOLOGY_ICON = '/icons/subjects/biology.png';
const ECONOMY_ICON = '/icons/subjects/economy.png';
const FRENCH_ICON = '/icons/subjects/french.png';
const ENGLISH_ICON = '/icons/subjects/english.png';
const DEUTSCH_SCHOOL_ICON = '/icons/subjects/deutsch.png';

const subjectIcons = {
  [SubjectType.Math]: MATH_SUBJECT_ICON,
  [SubjectType.English]: ENGLISH_ICON,
  [SubjectType.GermanSchool]: DEUTSCH_SCHOOL_ICON,
  [SubjectType.Physics]: PHYSICS_SUBJECT_ICON,
  [SubjectType.Latin]: LATIN_SUBJECT_ICON,
  [SubjectType.French]: FRENCH_ICON,
  [SubjectType.Chemistry]: CHEMISTRY_SUBJECT_ICON,
  [SubjectType.Economy]: ECONOMY_ICON,
  [SubjectType.Biology]: BIOLOGY_ICON,
  [SubjectType.TandemPartner]: CONVERSATION_ICON,
  [SubjectType.Other]: OTHER_ICON,
  [SubjectType.Spanish]: SPANISH_SUBJECT_ICON,
  [SubjectType.Italian]: ITALIAN_ICON,
  [SubjectType.Geography]: GEOGRAPHY_ICON,
  [SubjectType.History]: HISTORY_ICON,
  [SubjectType.BWL]: BWL_SUBJECT_ICON,
  [SubjectType.ComputerScience]: CS_ICON,
  [SubjectType.LearningCoaching]: COACHING_ICON,
  [SubjectType.DaF]: GERMANY_ICON,
  [SubjectType.Law]: LAW_ICON,
  [SubjectType.Accounting]: ACCOUNTING_ICON,
  [SubjectType.Accountancy]: ACCOUNTANCY_ICON,
  [SubjectType.Russian]: RUSSIAN_ICON,
  [SubjectType.LRSDyscalculia]: LRSDYSCALCULIA,
  [SubjectType.CoronaHelp]: LRSDYSCALCULIA, // Adobe XD had no icon for this subject so I reused another one that fit
  [SubjectType.GermanForRefugees]: GERMANY_ICON,
  [SubjectType.ConversationTraining]: CONVERSATION_ICON,
};

export const getSubjectIcon = (subject: SubjectType | undefined) =>
  subject ? subjectIcons[subject] : undefined;

export {
  BWL_SUBJECT_ICON,
  CHEMISTRY_SUBJECT_ICON,
  SPANISH_SUBJECT_ICON,
  MATH_SUBJECT_ICON,
  PHYSICS_SUBJECT_ICON,
  LATIN_SUBJECT_ICON,
};
